import api from "./data.services";
import {authService} from "./auth.service";

const displayDurationExamsSrv = 'display/duration/exams'
const getDisplayDurationExams = async () => {
    try {
        const resp: any = await api.get(`${displayDurationExamsSrv}`, authService.getToken())

        return {
            status: 'Ok',
            data: (resp.data ? resp.data : [])
        }
    } catch(error: any) {
        return {
            status: 'Error',
            message: (error && error.msg ? error.msg : 'Error server al obtener grupo familiar')
        }
    }
}

export const displayDurationExamService = {
    getDisplayDurationExams
}